import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import { Package, Users, ShoppingCart } from "lucide-react";

export function GlobalSearch({ open, setOpen }) {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState({ products: [], customers: [], orders: [] });

  const search = useCallback(async (val) => {
    if (!val) { setResults({ products: [], customers: [], orders: [] }); return; }
    try { const { data } = await api.get("/store/search", { params: { q: val } }); setResults(data); } catch {}
  }, []);

  useEffect(() => { const t = setTimeout(() => search(q), 200); return () => clearTimeout(t); }, [q, search]);

  const go = (path) => { setOpen(false); setQ(""); navigate(path); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search products, customers, orders..." value={q} onValueChange={setQ} data-testid="global-search-input" />
      <CommandList>
        <CommandEmpty>{q ? "No results found." : "Type to search across your store."}</CommandEmpty>
        {results.products.length > 0 && (
          <CommandGroup heading="Products">
            {results.products.map((p) => (
              <CommandItem key={p.id} value={`product-${p.id}-${p.name}`} onSelect={() => go(`/dashboard/products/${p.id}`)} data-testid={`search-product-${p.id}`}>
                <Package className="h-4 w-4 mr-2 text-muted-foreground" /> {p.name}{p.sku ? <span className="ml-2 text-xs text-muted-foreground">{p.sku}</span> : null}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.customers.length > 0 && (
          <CommandGroup heading="Customers">
            {results.customers.map((c) => (
              <CommandItem key={c.id} value={`customer-${c.id}-${c.name}`} onSelect={() => go(`/dashboard/customers/${c.id}`)} data-testid={`search-customer-${c.id}`}>
                <Users className="h-4 w-4 mr-2 text-muted-foreground" /> {c.name}<span className="ml-2 text-xs text-muted-foreground">{c.email}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.orders.length > 0 && (
          <CommandGroup heading="Orders">
            {results.orders.map((o) => (
              <CommandItem key={o.id} value={`order-${o.id}-${o.order_number}`} onSelect={() => go(`/dashboard/orders/${o.id}`)} data-testid={`search-order-${o.id}`}>
                <ShoppingCart className="h-4 w-4 mr-2 text-muted-foreground" /> {o.order_number} · {o.customer_name}<span className="ml-2 text-xs text-muted-foreground">{o.status}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
